import { useState } from "react";
import { workspaceInitials } from "@/lib/workspaceIcon";

const SIZE_CLASS = {
  xs: "h-6 w-6 text-[10px]",
  sm: "h-7 w-7 text-[11px]",
  md: "h-8 w-8 text-xs",
  lg: "h-10 w-10 text-sm",
  xl: "h-16 w-16 text-lg",
};

/**
 * Workspace avatar — logo image or initials fallback.
 * @param {{ name?: string, logoUrl?: string | null, size?: keyof SIZE_CLASS, shape?: "rounded" | "circle", className?: string }} props
 */
export default function WorkspaceIcon({
  name = "",
  logoUrl = null,
  size = "md",
  shape = "rounded",
  className = "",
}) {
  const [broken, setBroken] = useState(false);
  const showImage = Boolean(logoUrl) && !broken;
  const radius = shape === "circle" ? "rounded-full" : "rounded-xl";

  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center overflow-hidden border border-slate-200 bg-slate-50 font-semibold text-slate-400 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-500 ${SIZE_CLASS[size]} ${radius} ${className}`.trim()}
      aria-hidden
    >
      {showImage ? (
        <img
          src={logoUrl}
          alt=""
          className="h-full w-full object-cover"
          onError={() => setBroken(true)}
        />
      ) : (
        workspaceInitials(name)
      )}
    </span>
  );
}
